export const replaceAll = (
  str: string,
  pattern: string,
  replacement: string,
) => {
  return str.split(pattern).join(replacement);
};
